// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1og1_","question":"styles_question__1wJq8","description":"styles_description__62GsS"};